import { Section, SectionHeading, FadeIn } from "@/components/Section";
import { Lock, UserCog, FileLock2, FileClock, Network, DatabaseZap } from "lucide-react";

const PILLARS = [
  { icon: DatabaseZap, title: "Minimal-PHI design philosophy", desc: "Data architecture engineered to minimize PHI surface area by default." },
  { icon: UserCog, title: "Clinic-owned patient relationships", desc: "Clinics retain full ownership of patient relationships and clinical decisions." },
  { icon: Network, title: "Vendor independence", desc: "Vendors operate independently; Nodera coordinates, it does not direct care." },
  { icon: Lock, title: "Secure infrastructure", desc: "Hardened infrastructure with encryption in transit and at rest." },
  { icon: FileLock2, title: "Role-based access", desc: "Granular access controls at user, clinic, and vendor level." },
  { icon: FileClock, title: "Audit logging", desc: "Comprehensive, immutable activity trails across workflows and data access." },
];

export default function SecurityCompliance() {
  return (
    <Section testId="security-section" className="bg-white">
      <SectionHeading
        eyebrow="Security & Compliance"
        title="Built to minimize risk while enabling scale."
        intro="This platform provides operational infrastructure only and does not provide healthcare services, clinical oversight, or treatment functionality."
      />

      <div className="mt-14 grid lg:grid-cols-3 gap-6">
        {PILLARS.map((p, i) => (
          <FadeIn key={i} delay={i * 0.04}>
            <div className="h-full rounded-2xl border border-slate-200 bg-white p-6 hover:border-blue-200 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center">
                <p.icon className="w-4.5 h-4.5 text-slate-900" strokeWidth={1.8} />
              </div>
              <h3 className="mt-5 font-display text-base font-semibold text-slate-900">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.2}>
        <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-50 p-6 text-center">
          <p className="text-sm text-slate-600 max-w-3xl mx-auto">
            Nodera does not diagnose, prescribe, treat, interpret labs, provide medical advice, or manage patient care. It is strictly a software, workflow automation, operational enablement, and vendor orchestration platform serving licensed healthcare clinics.
          </p>
        </div>
      </FadeIn>
    </Section>
  );
}
